import { render, staticRenderFns } from "./AruMonthPicker.vue?vue&type=template&id=224c937c&"
import script from "./AruMonthPicker.vue?vue&type=script&lang=js&"
export * from "./AruMonthPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports